const listPreferenceOrderToSearchSort = (order) => {
  return {
    field: order.property,
    order: order.direction === "ASC" ? "asc" : "desc"
  };
};

export { listPreferenceOrderToSearchSort };
//# sourceMappingURL=listPreferenceOrderToSearchSort.js.map
